import React from 'react'
import styled from '@emotion/styled'
import { mediaDn, spacer } from 'stylist'
import FooterLink from './FooterLink'

const Container = styled.section`
  padding-top: ${spacer(6)};
  padding-bottom: ${spacer(6)};

  display: flex;
  justify-content: center;

  ${mediaDn('sm')} {
    flex-direction: column;
  }

  @supports (display: grid) {
    display: grid;
    grid-template-columns: repeat(3, auto);
    justify-content: center;

    ${mediaDn('sm')} {
      grid-template-columns: 1fr;
    }
  }
`

const HomeFooter = () => (
  <Container>
    <FooterLink href="https://help.focusvision.com/">Support</FooterLink>

    <FooterLink href="https://legal.forsta.com/legal/privacy-notice/">
     Privacy policy
    </FooterLink>

    <FooterLink href="https://legal.forsta.com/legal/forsta-acceptable-use-policy/">
     Acceptable use policy
    </FooterLink>
  </Container>
)

export default HomeFooter



// WEBPACK FOOTER //
// ./src/routes/components/FooterHome.js